import { formatNumber } from "@cakemail-org/ui-components-v2"
import { t } from "i18next"

export function getIndustryCat() {
    return [
        {
            text: t("industry-cat-technology"),
            value: "technology_and_it_services",
        },
        {
            text: t("industry-cat-commerce"),
            value: "e-commerce_and_retail",
        },
        {
            text: t("industry-cat-services"),
            value: "consumer_services",
        },
        {
            text: t("industry-cat-healthcare"),
            value: "healthcare",
        },
        {
            text: t("industry-cat-wellness"),
            value: "wellness_and_social_services",
        },
        {
            text: t("industry-cat-education"),
            value: "education_and_non-profit",
        },
        {
            text: t("industry-cat-professional"),
            value: "professional_services",
        },
        {
            text: t("industry-cat-creative"),
            value: "creative_and_media_services",
        },
        {
            text: t("industry-cat-financial"),
            value: "financial_services",
        },
        {
            text: t("industry-cat-entertainment"),
            value: "media_and_entertainment",
        },
        {
            text: t("industry-cat-travel"),
            value: "travel_and_hospitality",
        },
        {
            text: t("industry-cat-logistics"),
            value: "manufacturing_and_logistics",
        },
        {
            text: t("industry-cat-energy"),
            value: "energy_and_environmental_services",
        },
        {
            text: t("industry-cat-government"),
            value: "government_and_public_sector",
        },

    ]
}

export function getIndustries(category: string) {

    const industriesSector: Record<string, { text: string; value: string }[]> = {
        "technology_and_it_services": [
            {
                text: t("industry-sector-animation"),
                value: "animation",
            },
            {
                text: t("industry-sector-network-security"),
                value: "computer_and_network_security",
            },
            {
                text: t("industry-sector-computer-games"),
                value: "computer_games",
            },
            {
                text: t("industry-sector-computer-hardware"),
                value: "computer_hardware",
            },
            {
                text: t("industry-sector-computer-networking"),
                value: "computer_networking",
            },
            {
                text: t("industry-sector-computer-software"),
                value: "computer_software",
            },
            {
                text: t("industry-sector-information-services"),
                value: "information-services",
            },
            {
                text: t("industry-sector-information-tech"),
                value: "information_technology_and_services",
            },
            {
                text: t("industry-sector-internet"),
                value: "internet",
            },
            {
                text: t("industry-sector-nanotechnology"),
                value: "nanotechnology",
            },
            {
                text: t("industry-sector-semiconductors"),
                value: "semiconductors",
            },
            {
                text: t("industry-sector-telecommunications"),
                value: "telecommunications",
            },
            {
                text: t("industry-sector-wireless"),
                value: "wireless",
            }
        ],
        "e-commerce_and_retail": [
            {
                text: t("industry-sector-fashion"),
                value: "apparel_and_fashion",
            },
            {
                text: t("industry-sector-consumer-electronics"),
                value: "consumer-electronics",
            },
            {
                text: t("industry-sector-consumer-goods"),
                value: "consumer-goods",
            },
            {
                text: t("industry-sector-cosmetics"),
                value: "cosmetics",
            },
            {
                text: t("industry-sector-jewelry"),
                value: "luxury_goods_and_jewelry",
            },
            {
                text: t("industry-sector-retail"),
                value: "retail",
            },
            {
                text: t("industry-sector-sporting"),
                value: "sporting_goods",
            },
            {
                text: t("industry-sector-supermarkets"),
                value: "supermarkets",
            },
            {
                text: t("industry-sector-tobacco"),
                value: "tobacco",
            },
            {
                text: t("industry-sector-wine"),
                value: "wine_and_spirits",
            },
        ],
        "consumer_services": [
            {
                text: t("industry-sector-consumer_services"),
                value: "consumer_services",
            },
            {
                text: t("industry-sector-recreational_facilities"),
                value: "recreational_facilities_and_services",
            },
            {
                text: t("industry-sector-restaurants"),
                value: "restaurants",
            },
        ],
        "healthcare": [
            {
                text: t("industry-sector-biotechnology"),
                value: "biotechnology",
            },
            {
                text: t("industry-sector-hospital"),
                value: "hospital_and_health_care",
            },
            {
                text: t("industry-sector-medical_devices"),
                value: "medical_devices",
            },
            {
                text: t("industry-sector-medical_practice"),
                value: "medical_practice",
            },
            {
                text: t("industry-sector-mental_health"),
                value: "mental_health_care",
            },
            {
                text: t("industry-sector-pharmaceuticals"),
                value: "pharmaceuticals",
            },
            {
                text: t("industry-sector-veterinary"),
                value: "veterinary",
            },
        ],
        "wellness_and_social_services": [
            {
                text: t("industry-sector-alternative_medicine"),
                value: "alternative_medicine",
            },
            {
                text: t("industry-sector-health_and_fitness"),
                value: "health_wellness_and_fitness",
            },
            {
                text: t("industry-sector-family_services"),
                value: "individual_and_family_services",
            },
        ],
        "education_and_non-profit": [
            {
                text: t("industry-sector-social_organization"),
                value: "civic_and_social_organization",
            },
            {
                text: t("industry-sector-e-learning"),
                value: "e-learning",
            },
            {
                text: t("industry-sector-education_management"),
                value: "education_management",
            },
            {
                text: t("industry-sector-fund-raising"),
                value: "fund-raising",
            },
            {
                text: t("industry-sector-higher_education"),
                value: "higher_education",
            },
            {
                text: t("industry-sector-international_affairs"),
                value: "international_affairs",
            },
            {
                text: t("industry-sector-international_trade"),
                value: "international_trade_and_development",
            },
            {
                text: t("industry-sector-libraries"),
                value: "libraries",
            },
            {
                text: t("industry-sector-museums_institutions"),
                value: "museums_and_institutions",
            },
            {
                text: t("industry-sector-non-profit"),
                value: "non-profit_organization_management",
            },
            {
                text: t("industry-sector-philanthropy"),
                value: "philanthropy",
            },
            {
                text: t("industry-sector-political_organization"),
                value: "political_organization",
            },
            {
                text: t("industry-sector-education"),
                value: "primary_secondary_education",
            },
            {
                text: t("industry-sector-professional_training"),
                value: "professional_training_and_coaching",
            },
            {
                text: t("industry-sector-program_development"),
                value: "program_development",
            },
            {
                text: t("industry-sector-religious_institutions"),
                value: "religious_institutions",
            },
            {
                text: t("industry-sector-research"),
                value: "research",
            },
            {
                text: t("industry-sector-think_tanks"),
                value: "think_tanks",
            },
        ],
        "professional_services": [
            {
                text: t("industry-sector-accounting"),
                value: "accounting",
            },
            {
                text: t("industry-sector-dispute_resolution"),
                value: "alternative_dispute_resolution",
            },
            {
                text: t("industry-sector-architecture_planning"),
                value: "architecture_and_planning",
            },
            {
                text: t("industry-sector-commercial_real_estate"),
                value: "commercial_real_estate",
            },
            {
                text: t("industry-sector-executive_office"),
                value: "executive_office",
            },
            {
                text: t("industry-sector-human_resources"),
                value: "human_resources",
            },
            {
                text: t("industry-sector-import_export"),
                value: "import_and_export",
            },
            {
                text: t("industry-sector-law_practice"),
                value: "law_practice",
            },
            {
                text: t("industry-sector-legal_services"),
                value: "legal_services",
            },
            {
                text: t("industry-sector-management_consulting"),
                value: "management_consulting",
            },
            {
                text: t("industry-sector-market_research"),
                value: "market_research",
            },
            {
                text: t("industry-sector-outsourcing_offshoring"),
                value: "outsourcing_offshoring",
            },
            {
                text: t("industry-sector-staffing_recruiting"),
                value: "staffing_and_recruiting",
            },
            {
                text: t("industry-sector-translation_localization"),
                value: "translation_and_localization",
            },
            {
                text: t("industry-sector-real_estate"),
                value: "real_estate",
            },
        ],
        "creative_and_media_services": [
            {
                text: t("industry-sector-design"),
                value: "design",
            },
            {
                text: t("industry-sector-graphic_design"),
                value: "graphic_design",
            },
            {
                text: t("industry-sector-marketing_advertising"),
                value: "marketing_and_advertising",
            },
            {
                text: t("industry-sector-media_production"),
                value: "media_production",
            },
            {
                text: t("industry-sector-photography"),
                value: "photography",
            },
            {
                text: t("industry-sector-public_relations"),
                value: "public_relations_and_communications",
            },
            {
                text: t("industry-sector-publishing"),
                value: "publishing",
            },
            {
                text: t("industry-sector-writing_editing"),
                value: "writing_and_editing",
            },
        ],
        "financial_services": [
            {
                text: t("industry-sector-banking"),
                value: "banking",
            },
            {
                text: t("industry-sector-capital_markets"),
                value: "capital_markets",
            },
            {
                text: t("industry-sector-financial_services"),
                value: "financial_services",
            },
            {
                text: t("industry-sector-insurance"),
                value: "insurance",
            },
            {
                text: t("industry-sector-investment_banking"),
                value: "investment_banking",
            },
            {
                text: t("industry-sector-investment_management"),
                value: "investment_management",
            },
            {
                text: t("industry-sector-venture_capital"),
                value: "venture_capital_and_private_equity",
            },
        ],
        "media_and_entertainment": [
            {
                text: t("industry-sector-arts_crafts"),
                value: "arts_and_crafts",
            },
            {
                text: t("industry-sector-broadcast_media"),
                value: "broadcast_media",
            },
            {
                text: t("industry-sector-entertainment"),
                value: "entertainment",
            },
            {
                text: t("industry-sector-fine_art"),
                value: "fine_art",
            },
            {
                text: t("industry-sector-gambling"),
                value: "gambling_and_casinos",
            },
            {
                text: t("industry-sector-film"),
                value: "motion_pictures_and_film",
            },
            {
                text: t("industry-sector-music"),
                value: "music",
            },
            {
                text: t("industry-sector-newspapers"),
                value: "newspapers",
            },
            {
                text: t("industry-sector-online_media"),
                value: "online_media",
            },
            {
                text: t("industry-sector-performing_arts"),
                value: "performing_arts",
            },
            {
                text: t("industry-sector-sports"),
                value: "sports",
            },
        ],
        "travel_and_hospitality": [
            {
                text: t("industry-sector-airlines"),
                value: "airlines_aviation",
            },
            {
                text: t("industry-sector-events_services"),
                value: "events_services",
            },
            {
                text: t("industry-sector-hospitality"),
                value: "hospitality",
            },
            {
                text: t("industry-sector-travel_tourism"),
                value: "leisure_travel_and_tourism",
            },
            {
                text: t("industry-sector-maritime"),
                value: "Maritime",
            },
        ],
        "manufacturing_and_logistics": [
            {
                text: t("industry-sector-automotive"),
                value: "automotive",
            },
            {
                text: t("industry-sector-aviation_aerospace"),
                value: "aviation_and_aerospace",
            },
            {
                text: t("industry-sector-building_materials"),
                value: "building_materials",
            },
            {
                text: t("industry-sector-business_supplies"),
                value: "business_supplies_and_equipment",
            },
            {
                text: t("industry-sector-chemicals"),
                value: "chemicals",
            },
            {
                text: t("industry-sector-civil_engineering"),
                value: "civil_engineering",
            },
            {
                text: t("industry-sector-construction"),
                value: "construction",
            },
            {
                text: t("industry-sector-dairy"),
                value: "dairy",
            },
            {
                text: t("industry-sector-defense_space"),
                value: "defense_and_space",
            },
            {
                text: t("industry-sector-electronic_manufacturing"),
                value: "electrical_electronic_manufacturing",
            },
            {
                text: t("industry-sector-facilities_services"),
                value: "facilities_services",
            },
            {
                text: t("industry-sector-farming"),
                value: "farming",
            },
            {
                text: t("industry-sector-fishery"),
                value: "fishery",
            },
            {
                text: t("industry-sector-food_beverages"),
                value: "food_and_beverages",
            },
            {
                text: t("industry-sector-food_production"),
                value: "food_production",
            },
            {
                text: t("industry-sector-furniture"),
                value: "furniture",
            },
            {
                text: t("industry-sector-glass_ceramics"),
                value: "glass_ceramics_and_concrete",
            },
            {
                text: t("industry-sector-industrial_automation"),
                value: "industrial_automation",
            },
            {
                text: t("industry-sector-logistics_supply"),
                value: "logistics_and_supply_chain",
            },
            {
                text: t("industry-sector-machinery"),
                value: "machinery",
            },
            {
                text: t("industry-sector-industrial_engineering"),
                value: "mechanical_or_industrial_engineering",
            },
            {
                text: t("industry-sector-mining_metals"),
                value: "mining_and_metals",
            },
            {
                text: t("industry-sector-oil_energy"),
                value: "oil_and_energy",
            },
            {
                text: t("industry-sector-freight_delivery"),
                value: "package_freight_delivery",
            },
            {
                text: t("industry-sector-packaging_containers"),
                value: "packaging_and_containers",
            },
            {
                text: t("industry-sector-forest_products"),
                value: "paper_and_forest_products",
            },
            {
                text: t("industry-sector-plastics"),
                value: "plastics",
            },
            {
                text: t("industry-sector-printing"),
                value: "printing",
            },
            {
                text: t("industry-sector-railroad_manufacture"),
                value: "railroad_manufacture",
            },
            {
                text: t("industry-sector-ranching"),
                value: "ranching",
            },
            {
                text: t("industry-sector-shipbuilding"),
                value: "shipbuilding",
            },
            {
                text: t("industry-sector-textiles"),
                value: "textiles",
            },
            {
                text: t("industry-sector-transportation"),
                value: "transportation_trucking_railroad",
            },
            {
                text: t("industry-sector-warehousing"),
                value: "warehousing",
            },
            {
                text: t("industry-sector-wholesale"),
                value: "wholesale",
            },
        ],
        "energy_and_environmental_services": [
            {
                text: t("industry-sector-environmental_services"),
                value: "environmental_services",
            },
            {
                text: t("industry-sector-renewables_environment"),
                value: "renewables_and_environment",
            },
            {
                text: t("industry-sector-utilities"),
                value: "utilities",
            },
        ],
        "government_and_public_sector": [
            {
                text: t("industry-sector-government_administration"),
                value: "government_administration",
            },
            {
                text: t("industry-sector-government_relations"),
                value: "government_relations",
            },
            {
                text: t("industry-sector-judiciary"),
                value: "judiciary",
            },
            {
                text: t("industry-sector-law_enforcement"),
                value: "law_enforcement",
            },
            {
                text: t("industry-sector-legislative_office"),
                value: "legislative_office",
            },
            {
                text: t("industry-sector-military"),
                value: "military",
            },
            {
                text: t("industry-sector-public_policy"),
                value: "public_policy",
            },
            {
                text: t("industry-sector-public_safety"),
                value: "public_safety",
            },
            {
                text: t("industry-sector-security_investigations"),
                value: "security_and_investigations",
            },
        ],
    }

    return industriesSector[category] || industriesSector["technology_and_it_services"]
}

export function getTeamSize() {
    return [
        {
            text: t("general-employee-txt", { size: 1 }),
            value: "1",
        },
        {
            text: t("general-employees-txt", { size: "2-10" }),
            value: "2-10",
        },
        {
            text: t("general-employees-txt", { size: "11-50" }),
            value: "11-50",
        },
        {
            text: t("general-employees-txt", { size: "51-200" }),
            value: "51-200",
        },
        {
            text: t("general-employees-txt", { size: "201-500" }),
            value: "201-500",
        },
        {
            text: t("general-employees-txt", { size: `501-${formatNumber(1000)}` }),
            value: "501-1000",
        },
        {
            text: t("general-employees-txt", { size: `${formatNumber(1001)}-${formatNumber(5000)}` }),
            value: "1001-5000",
        },
        {
            text: t("general-employees-txt", { size: `${formatNumber(5001)}+` }),
            value: "5001-10000000000000000",
        },

    ]
}